export const FAQ = () => <div>FAQ</div>;
